/* eslint-disable eqeqeq */
import {
  CmpSelectBox,
  CmpTextFieldEnter,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import useMediaQuery from "@mui/material/useMediaQuery";
import Radio from "@mui/material/Radio";
import "./StockEnquiry.css";
import { StockEnQuirySummaryTblCard } from "./processComponent/StockEnQuirySummaryTblCard";
import { StockEnQuiryBinSummaryTblCard } from "./processComponent/StockEnQuiryBinSummaryTblCard";

const GridcolumnsBin_Def = [
  {
    field: "ItmCd",
    headerName: "Item Code",
    width: 150,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "ItmName",
    headerName: "Item Name",
    width: 300,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "SuppRefNo1",
    headerName: "RefNo",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  // {
  //   field: "CARDID",
  //   headerName: "Card Id",
  //   width: 250,
  //   hide: true,
  // },
  {
    field: "Qty",
    headerName: "Qty",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
];
const GridcolumnsBiDropid_Def = [
  {
    field: "ItmCd",
    headerName: "Item Code",
    width: 150,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "ItmName",
    headerName: "Item Name",
    width: 300,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "SuppRefNo1",
    headerName: "RefNo",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  // {
  //   field: "Drop_ID",
  //   headerName: "Drop ID",
  //   width: 150,
  //   align: "center",
  //   headerAlign: "center",
  // },
  // {
  //   field: "CARDID",
  //   headerName: "Card Id",
  //   width: 250,
  //   hide: true,
  // },
  {
    field: "Qty",
    headerName: "Qty",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
];

const GridcolumnsCARD_Def = [
  {
    field: "ItmCd",
    headerName: "Item Code",
    width: 150,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "ItmName",
    headerName: "Item Name",
    width: 300,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "SuppRefNo1",
    headerName: "RefNo",
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "BinName",
    headerName: "Bin Name",
    width: 300,
    align: "center",
    headerAlign: "center",
  },
  // {
  //   field: "CARDID",
  //   headerName: "Card Id",
  //   width: 250,
  //   hide: true,
  // },
  {
    field: "Qty",
    headerName: "Qty",
    width: 100,
    align: "right",
    headerAlign: "right",
  },
];
export default function StockEnquiry() {
  const LocFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  // eslint-disable-next-line no-unused-vars
  const [sLocation, SetLocation] = useState(vRdxuserLoc);
  const [sLoadObj, setLoadObj] = useState({
    type: "CARDID",
    code: "",
    loc: vRdxuserLoc[0]?.UID,
    codeLabel:"",
  });
  const [sGridrows, setGridrows] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });

  const fOnChangeInput = (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));

    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    if (
      e.target.value.length < sLoadObj.code.toString().length &&
      vMediaQuery &&
      e.target.name === "code"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      if (e.target.value !== "" && vMediaQuery) {
        fOnKeyUp(vBackspaceObj);
      }
    }
  };
  const fOnKeyUp = async (e) => {
    if (e.key === "Enter") {
      GetSummaryList(sLoadObj.type, sLoadObj.code, sLoadObj.loc);
    } else if (e.key === "Backspace") {
      setLoadObj((obj) => ({
        ...obj,
        codeLabel:""
      }));
      setGridrows([]);
    }
  };
  const fFromRadioButton = (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      codeLabel:""
    }));
    setGridrows([])
    if (sLoadObj.code !== "") {
      GetSummaryList(e.target.value, sLoadObj.code, sLoadObj.loc);
    }
    LocFocusOnLoad.current?.focus();
  };
  const fOnChangeSelect = (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
    GetSummaryList(sLoadObj.type, sLoadObj.code, e.target.value);
  };
  const fLoad = async (e) => {
    setLoadObj((obj) => ({
      ...obj,
      loc: vRdxuserLoc[0]?.UID,
    }));
    GetSummaryList(sLoadObj.type, sLoadObj.code, vRdxuserLoc[0]?.UID);
  };

  //API BIN_ENQUIRY_GETROW
  const GetSummaryList = async (xtype, xcode, xloc) => {
    let vSummaryListObj = {
      v_Type: xtype,
      v_BinCd:
        xtype === "BIN" ||
        xtype === "BARCODE" ||
        xtype === "DROPID" ||
        xtype === "REFNO"
          ? xcode
          : "",
      v_CardId: xtype === "CARDID" && xcode != "" ? xcode : 0,
      v_Loc: xloc,
    };
    const vSummaryList = await fExecuteAPI(
      "BIN_ENQUIRY_GETROW",
      vSummaryListObj
    );
    if (vSummaryList.Type == "SUCCESS") {
      let GridID = vSummaryList.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridrows(GridID);
      setLoadObj((obj) => ({
        ...obj,
        code: "",
        codeLabel:sLoadObj.code
      }));
    } else {
      fAlertToast("FAILED", vSummaryList.response.data.Status);
      let GridID = [];
      setGridrows(GridID);
      setLoadObj((obj) => ({
        ...obj,
        code: "",
        codeLabel:""
      }));
    }
  };
  useEffect(() => {
    fLoad();
  }, []);

  useEffect(() => {
    LocFocusOnLoad.current?.focus();
  }, []);

  const [GridcolumnsBin, setGridcolumnsBin] = useState(GridcolumnsBin_Def);
  const [GridcolumnsCARD, setGridcolumnsCARD] = useState(GridcolumnsCARD_Def);
  const [GridcolumnsDropID, setGridcolumnsDropID] = useState(GridcolumnsBiDropid_Def);

  useEffect(() => {
    GetGitterColumns(setGridcolumnsCARD, "StockEnquiry_card", GridcolumnsCARD);
    GetGitterColumns(setGridcolumnsBin, "StockEnquiry_Bin", GridcolumnsBin);
    GetGitterColumns(setGridcolumnsDropID, "StockEnquiry_Bin", GridcolumnsDropID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-fluid my-3">
      <div className="Instant-picking-head">
        <Grid container spacing={2}>
          <Grid item md={12} xs={12} className="bintransfer-data-date  ">
            <Grid container spacing={2}>
              <Grid
                item
                md={"auto"}
                xs={'auto'}
                className="d-flex align-items-center"
              >
                <Radio
                  checked={sLoadObj.type === "CARDID"}
                  onChange={fFromRadioButton}
                  value="CARDID"
                  name="type"
                />
                <span className="title-f ">CardID</span>
              </Grid>
              <Grid
                item
                md={"auto"}
                xs={'auto'}
                className="d-flex align-items-center"
              >
                <Radio
                  checked={sLoadObj.type === "BIN"}
                  onChange={fFromRadioButton}
                  value="BIN"
                  name="type"
                />
                <span className="title-f">Bin</span>
              </Grid>
              <Grid
                item
                md={"auto"}
                xs={'auto'}
                className="d-flex align-items-center"
              >
                <Radio
                  checked={sLoadObj.type === "BARCODE"}
                  onChange={fFromRadioButton}
                  value="BARCODE"
                  name="type"
                />
                <span className="title-f">Barcode</span>
              </Grid>
              <Grid
                item
                md={"auto"}
                xs={'auto'}
                className="d-flex align-items-center"
              >
                <Radio
                  checked={sLoadObj.type === "DROPID"}
                  onChange={fFromRadioButton}
                  value="DROPID"
                  name="type"
                />
                <span className="title-f">Drop Id</span>
              </Grid>
              <Grid
                item
                md={"auto"}
                xs={'auto'}
                className="d-flex align-items-center"
              >
                <Radio
                  checked={sLoadObj.type === "REFNO"}
                  onChange={fFromRadioButton}
                  value="REFNO"
                  name="type"
                />
                <span className="title-f">Reference No</span>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={4} md={4} xs={12}>
            <CmpSelectBox
              xLabelText="Location"
              xValue={sLoadObj.loc === "" ? vRdxuserLoc[0]?.UID : sLoadObj.loc}
              xOnChange={(event) => fOnChangeSelect(event)}
              xName={"loc"}
              xData={sLocation}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={4} md={4} xs={12}>
            <CmpTextFieldEnter
              xref={LocFocusOnLoad}
              xLabelText={sLoadObj.type}
              xVariant={"outlined"}
              xValue={sLoadObj.code}
              xOnChange={(event) => fOnChangeInput(event)}
              xReadOnly={false}
              xType={"text"}
              xName={"code"}
              xOnKeyUp={(e) => {
                fOnKeyUp(e);
              }}
              xOnEnter={(e) => {
                fOnKeyUp(sEnterKeyObj);
              }}
              xSmShow={!!vMediaQuery}
            />
          </Grid>
        
        </Grid>
        <div className="pt-2">
        { sLoadObj.codeLabel && (
         <CmpTypographyField
         xcomponent={"span"}
         xText={"Code : " + sLoadObj.codeLabel}
       />
      )}
        </div>
        {sLoadObj.type == "BIN" ? (
          // <Box
          //   sx={{ height: vMediaQuery ? "60vh" : "70vh", width: "100%" }}
          //   className="bin-transfer-data"
          // >
          //   <DataGrid
          //     rowHeight={30}
          //     headerHeight={40}
          //     getRowClassName={(params) =>
          //       params.indexRelativeToCurrentPage % 2 === 0
          //         ? "mui-even-row"
          //         : "mui-odd-row"
          //     }
          //     sx={{
          //       border: 1,
          //       borderColor: "primary.light",
          //     }}
          //     rows={sGridrows}
          //     columns={GridcolumnsBin}
          //     // pageSize={5}
          //     // rowsPerPageOptions={[5]}
          //     hideFooter={sGridrows.length < 100}
          //     components={{
          //       Toolbar: vMediaQuery ? "" : GridToolbar,
          //     }}
          //     // onRowClick={fOnRowClick}
          //   />
 
          // </Box>
          <StockEnQuiryBinSummaryTblCard data={sGridrows} />
        )  : (
          // <Box
          //   sx={{ height: vMediaQuery ? "60vh" : "70vh", width: "100%" }}
          //   className="bin-transfer-data"
          // >
          //   <DataGrid
          //     rowHeight={30}
          //     headerHeight={40}
          //     getRowClassName={(params) =>
          //       params.indexRelativeToCurrentPage % 2 === 0
          //         ? "mui-even-row"
          //         : "mui-odd-row"
          //     }
          //     sx={{
          //       border: 1,
          //       borderColor: "primary.light",
          //     }}
          //     rows={sGridrows}
          //     columns={GridcolumnsCARD}
          //     // pageSize={5}
          //     // rowsPerPageOptions={[5]}
          //     hideFooter={sGridrows.length < 100}
          //     components={{
          //       Toolbar: vMediaQuery ? "" : GridToolbar,
          //     }}
          //     // onRowClick={fOnRowClick}
          //   />
          // </Box>
          <StockEnQuirySummaryTblCard data={sGridrows} />
        )}
        
      </div>
    </div>
  );
}
